import React, { Component } from "react";
import { PropertyResultProps } from "./PropertyResultListView";
import GridDataView, { GRID_SIZE } from "@my-dld/components/DataView/GridDataView";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { EjariProperty } from "@eres/ejari-api/Entity";
import { I8N } from "@eres/core";
import Strings from "@my-dld/assets/strings";
import { UNIT } from "./SearchProperty";

interface State {
	searchKey?: string;
	page: number;
}

class PropertyResultGridView extends Component<PropertyResultProps, State> {
	constructor( props: PropertyResultProps ) {
		super( props );
		this.state = {
			page: 1,
		};
	}

	render() {
		const { propertyType, properties, onDetails } = this.props;
		const { searchKey } = this.state;
		const filterData = this.getFilterData( searchKey );
		return <GridDataView
			items={ this.getPageData( filterData ) }
			onSearch={ this.onSearch }
			renderGridItem={ ( item: EjariProperty ) => {
				return <RenderGridItem
					key={ `prop_res_${ item.PropertyId }` }
					propertyType={ propertyType }
					item={ item }
					onDetails={ onDetails }/>;
			} }
			totalCount={ !isEmptyStringOrNull( searchKey ) ? filterData.length : properties.length }
			onPageChange={ this.onPageChange }/>;
	}

	private getFilterData( sKey?: string ) {
		const { properties } = this.props;
		if ( sKey ) {
			return properties.filter( ( item: EjariProperty ) => {
				const filterKeys: string[] = [];
				filterKeys.push( !isEmptyStringOrNull( item.UnitNo ) ? item.UnitNo : "" );
				filterKeys.push( I8N.isRTL() ? item.BuildingNameAr : item.BuildingNameEn );
				filterKeys.push( I8N.isRTL() ? item.AreaAr : item.AreaEn );
				filterKeys.push( item.IsRented ? Strings.rented : Strings.vacant );
				const fItem = filterKeys.find( ( fKey: string ) => fKey.toLocaleLowerCase().includes( sKey.toLocaleLowerCase() ) );
				return fItem != undefined;
			} );
		}
		return properties;
	}

	private getPageData( filterData: EjariProperty[] ) {
		const { page } = this.state;
		return filterData.slice( ( page - 1 ) * GRID_SIZE, page * GRID_SIZE );
	}

	private onSearch = ( sKey?: string ) => {
		this.setState( {
			searchKey: sKey,
			page: 1
		} );
	};

	private onPageChange = ( page: number ) => {
		this.setState( { page: page } );
	};
}

function RenderGridItem( props: { propertyType: number, item: EjariProperty, onDetails: ( req: EjariProperty ) => void } ) {
	const { propertyType, item, onDetails } = props;
	const unitNo = !isEmptyStringOrNull( item.UnitNo ) ? item.UnitNo : "";
	const isUnit = propertyType === UNIT.Id;
	return <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 property-card">
		<div className="card">
			<div className="card-body custom-body">
				<div className="detail-holder">
					<div className="custom-card-title">
						<div>
							<span>{ I8N.isRTL() ? item.BuildingNameAr : item.BuildingNameEn }</span>
							<span>{ isUnit ? Strings.building_name : Strings.villa_name }</span>
						</div>
						<div className="property-status-position">
							<span>{ item.IsRented ? Strings.rented : Strings.vacant }</span>
							<span>{ Strings.property_status.replace( "<br/>", "" ) }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-detail">
						<div className="col-8">
							<span>{ I8N.isRTL() ? item.AreaAr : item.AreaEn }</span>
							<span>{ Strings.area_label }</span>
						</div>
						{ isUnit && <div className="col-4">
							<span>{ unitNo }</span>
							<span>{ Strings.Unit_Number_Label }</span>
						</div> }
					</div>
					<div className="row no-gutters property-card-action">
						<div className="col-md-12">
							<button
								className="btn-link"
								onClick={ () => onDetails( item ) }>{ Strings.view_details }</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>;
}

export default PropertyResultGridView;
